module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-SPORT-7.7ea7b2d0.jpg";